import { INITIALIZE_CONFIG } from '../actions/constants/ActionTypes';

const Config = (state = {}, action) => {
  switch (action.type) {
    case INITIALIZE_CONFIG:
      return action.config;

    default:
      return state;
  }
};

export default Config;